import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TimeseriesState } from './time-series.reducer';
export const selectTimeSeriesData = createFeatureSelector<TimeseriesState>('timeSeries');

export const selectedTimeSeriesItems = createSelector(selectTimeSeriesData, (state) => {
  return state.data;
});

export const selectTimeseriesState = createFeatureSelector<TimeseriesState>('timeseries');

// select all timeseries data
export const selectTimeseriesData = createSelector(selectTimeseriesState, (state) => state.data);

// optional: select a single TS key
export const selectInstrumentTS = createSelector(selectTimeseriesState, (state) => state.data);
